var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20938 1.08124H1.99097C1.59554 1.08124 1.21631 1.23832 0.936696 1.51793C0.657084 1.79755 0.5 2.17678 0.5 2.57221V13.009C0.5 13.4044 0.657084 13.7837 0.936696 14.0633C1.21631 14.3429 1.59554 14.5 1.99097 14.5H12.4278C12.8232 14.5 13.2024 14.3429 13.4821 14.0633C13.7617 13.7837 13.9188 13.4044 13.9188 13.009V7.79061",
    stroke: "#34B714",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 13.625V12.7083C10.333 12.2221 10.1399 11.7558 9.79604 11.412C9.45222 11.0682 8.9859 10.875 8.49967 10.875H5.29134C4.80511 10.875 4.3388 11.0682 3.99498 11.412C3.65116 11.7558 3.45801 12.2221 3.45801 12.7083V13.625",
    stroke: "#34B714",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89583 9.04167C7.90836 9.04167 8.72917 8.22086 8.72917 7.20833C8.72917 6.19581 7.90836 5.375 6.89583 5.375C5.88331 5.375 5.0625 6.19581 5.0625 7.20833C5.0625 8.22086 5.88331 9.04167 6.89583 9.04167Z",
    stroke: "#34B714",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.91667L11.9167 3.83333L13.75 2",
    stroke: "#34B714",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/Assign.509ff3e646b5bd968af375a960cc7cc2.svg";
export { ForwardRef as ReactComponent };